import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "file-preview-body"
};
import { toRefs, watch } from 'vue';
import PreviewComp from './Preview.vue';
export default {
  __name: 'FilePreviewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible', 'close'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var _toRefs = toRefs(props),
      visible = _toRefs.visible;

    // 监听外部props变化
    watch(function () {
      return props.visible;
    }, function (val) {
      // console.log('val', val)
      visible.value = val;
    }, {
      immediate: true
    });
    var handleClose = function handleClose() {
      visible.value = false;
      emit('update:visible', false);
      emit('close', false);
    };
    return function (_ctx, _cache) {
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: _unref(visible),
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(visible) ? visible.value = $event : null;
        }),
        width: "66%",
        placement: "center",
        header: "文件预览",
        attach: "body",
        class: "file-preview-dialog",
        "on-close": handleClose
      }, {
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(PreviewComp, {
            path: __props.path
          }, null, 8, ["path"])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};